export const legalFormList = [
  { value: '1', name: 'Fundacja' },
  { value: '2', name: 'Inny' },
  { value: '3', name: 'Organizacje kościelne i związki wyz.' },
  { value: '4', name: 'Porozumienia organizacji' },
  { value: '5', name: 'Przedsięb. indywidualne(indywid. właśc.)' },
  { value: '6', name: 'Przedsiębiorstwo państwowe' },
  { value: '7', name: 'Samorządowe jednostki' },
  { value: '8', name: 'Spółdzielnia' },
  { value: '9', name: 'Spółka Akcyjna' },
  { value: '10', name: 'Spółka Cywilna' },
  { value: '11', name: 'Spółka Jawna' },
  { value: '12', name: 'Spółka Komandytowa' },
  { value: '13', name: 'Spółka Komandytowo-Akcyjna' },
  { value: '14', name: 'Spółka Partnerska' },
  { value: '15', name: 'Spółka z ograniczona odpowiedzialnością' },
  { value: '16', name: 'Stowarzyszenie' },
  { value: '17', name: 'Szkoła, uczelnia, przedszkole' },
  { value: '18', name: 'Szpital, ZOZ, przychodnia' },
  { value: '19', name: 'Związek zawodowy' },
  { value: '20', name: 'Bez szczeg. formy prawnej' },
  { value: '21', name: 'Gmin. Samorz. Jedn. Organi.' },
  { value: '22', name: 'Oddziały Przeds. Zagranicz.' },
  { value: '23', name: 'Organy Władz. Administ. Rząd.' },
  { value: '24', name: 'Państ. Jedn. Organi.' },
  { value: '25', name: 'Pow. Samorz. Jedn. Organi.' },
  { value: '27', name: 'Przedstaw. Zagraniczne' },
  { value: '28', name: 'Wspólnoty_Mieszkaniowe' },
];
